module.exports = __webpack_public_path__ + "img/shequ_not.73309753.png";